package com.islamicmedia.shared.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * One comment on a shared, public thread for an analyzed title — every user who views the same
 * title sees the same thread. [isMine] is computed server-side from the caller's own auth token,
 * never client-trusted, and gates the edit/delete affordances in the UI.
 */
@Serializable
data class Comment(
    val id: String,
    @SerialName("first_name") val firstName: String,
    val body: String,
    @SerialName("created_at") val createdAt: String,
    @SerialName("edited_at") val editedAt: String? = null,
    @SerialName("is_mine") val isMine: Boolean = false
)

/** GET /api/comments response: the full thread + reaction tally + the caller's own reaction. */
@Serializable
data class CommentsResult(
    val comments: List<Comment> = emptyList(),
    @SerialName("like_count") val likeCount: Int = 0,
    @SerialName("dislike_count") val dislikeCount: Int = 0,
    /** 1 = like (thumbs up), -1 = dislike (thumbs down), null = no reaction from the caller. */
    @SerialName("my_reaction") val myReaction: Int? = null
)
